import Uploads from "./Uploads";
export default Uploads;
